export const environment = {
  API_ADDRESS: 'https://api.stage.infinitform.com',
  FRONTEND_ADDRESS: 'https://cabinet.stage.infinitform.com',
  EDITOR_ADDRESS: 'https://editor.stage.infinitform.com',
  SOCKET_ADDRESS: 'wss://wss.stage.infinitform.com/stage',
  API_STORAGE_MODE: 's3',
  SUBSCRIPTIONS_ENABLED: true,
  PRODUCTION: false,
  ENV_LABEL: 'STAGE'
};
